var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH731(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ffd15c;}.cls-2{mix-blend-mode:screen;}.cls-3{fill:#fff;opacity:0;}.cls-4{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.82,
    y: 27.74,
    width: 118.36,
    height: 144.52,
    rx: 12.62,
    ry: 12.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 69.41,
    cy: 56.19,
    r: 15.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.94,
    y: 84.98,
    width: 84.79,
    height: 21.61,
    rx: 10.81,
    ry: 10.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.94,
    y: 123.56,
    width: 84.79,
    height: 21.61,
    rx: 10.81,
    ry: 10.81
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH731);
export default __webpack_public_path__ + "static/media/H73-1.4afc42e8c03a1035423500f830c7d042.svg";
export { ForwardRef as ReactComponent };